import {ConfigsProperties} from "./index";


const config: ConfigsProperties = {
    BASE_API: 'https://dms.fosundiagnostics.com:8080/',
    SHA1_SALT: '6sJJnUiq',
    QINIU_HOST: 'http://cdn-srm-test.xmiws.com/',
    MINIO_HOST: 'https://dms.fosundiagnostics.com:9000/fosun/'
}

export default config
